import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const RightArrowIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.60022 13.0333L10.4002 8.23332L5.60022 3.43333"
      stroke="#141E30"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
export default RightArrowIcon;
